import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import Breadcrumb from "component/common/breadcrumb";
import {
  emailAddressValid,
  handleDetailResponse,
  mobileNumberValid,
  pancardValidation,
  seo,
  validateAadhaar,
  nameValid,
  isEmpty
} from "utils/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  bulkVerifyVisitForm,
  verifyVisitDetail,
  visitorDetail,
} from "../../reduxStore/action/visitorActions";
import moment from "moment";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";

const CreateLead = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const [viewData, setViewData] = useState({});
  const [formVaild, setFormVaild] = useState(null);
  const params = useParams();
  const { _id: customer_id } = params || {};
  const lead_id = new URLSearchParams(window.location.search).get("lead_id");

  const visitSelector = useSelector((state) => state.visitor) || [];

  const dispatch = useDispatch();
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  // useEffect(() => {
  //   const { detail, response } = visitSelector;
  //   if (detail && response) {
  //     setForm({ ...handleDetailResponse(response.data) });
  //   }
  // }, [visitSelector]);

  const verifyVisitorDetailSelector =
    useSelector((state) => state.visitor) || [];

  const bulkVerifyVisitDataSelector =
    useSelector((state) => state.bulkVerifyVisitForm) || [];

  useEffect(() => {
    if (bulkVerifyVisitDataSelector.detail) {
      dispatch(bulkVerifyVisitForm(bulkVerifyVisitDataSelector.response.data));
    }
  }, [bulkVerifyVisitDataSelector]);

  useEffect(() => {
    if (verifyVisitorDetailSelector.detail) {
      const { response } = verifyVisitorDetailSelector;
      if (response?.status === 200) {
        setViewData(handleDetailResponse(response.data));
        const result = handleDetailResponse(response?.data);
        setForm({
          ...form,
          user_id: result?.user_id,
          property_id: result?.property_id,
          property_title: result?.property_title,
          first_name: result?.first_name
            ? result?.first_name
            : result?.customer_detail?.first_name,
          marital_status: result?.marital_status
            ? result?.marital_status
            : result?.customer_detail?.marital_status,
          adhar_no: result?.adhar_no
            ? result?.adhar_no
            : result?.customer_detail?.adhar_no,
          pancard_no: result?.pancard_no
            ? result?.pancard_no
            : result?.customer_detail?.pancard_no,
          current_stay: result?.current_stay
            ? result?.current_stay
            : result?.customer_detail?.current_stay,
          no_of_family_member: result?.no_of_family_member
            ? result?.no_of_family_member
            : result?.customer_detail?.no_of_family_member,
          gender: result?.gender
            ? result?.gender
            : result?.customer_detail?.gender,
          birth_date: result?.birth_date
            ? moment(result?.birth_date).format("yyyy-MM-DD")
            : moment(result?.customer_detail?.birth_date).format("yyyy-MM-DD"),
          mobile: result?.mobile
            ? result?.mobile
            : result?.customer_detail?.mobile,
          whatsapp_no: result?.whatsapp_no
            ? result?.whatsapp_no
            : result?.customer_detail?.whatsapp_no,
          email: result?.email ? result?.email : result?.customer_detail?.email,
          location: result?.location
            ? result?.location
            : result?.customer_detail?.location,
          latitude: result?.latitude
            ? result?.latitude
            : result?.customer_detail?.latitude,
          longitude: result?.longitude
            ? result?.longitude
            : result?.customer_detail?.longitude,
          locality: result?.locality
            ? result?.locality
            : result?.customer_detail?.locality,
          configuration: result?.configuration
            ? result?.configuration
            : result?.customer_detail?.configuration,
          configuration_id: result?.configuration_id
            ? result?.configuration_id
            : result?.customer_detail?.configuration_id,
          expected_possession_date: result?.expected_possession_date
            ? moment(result?.expected_possession_date).format("yyyy-MM-DD")
            : moment(result?.customer_detail?.expected_possession_date).format(
              "yyyy-MM-DD"
            ),
          property_type: result?.property_type
            ? result?.property_type
            : result?.customer_detail?.property_type,
          areain_sqlft: result?.areain_sqlft
            ? result?.areain_sqlft
            : result?.customer_detail?.areain_sqlft,
          min_budget: result?.min_budget
            ? result?.min_budget
            : result?.customer_detail?.min_budget,
          max_budget: result?.max_budget
            ? result?.max_budget
            : result?.customer_detail?.max_budget,
          min_budget_type: result?.min_budget_type
            ? result?.min_budget_type
            : result?.customer_detail?.min_budget_type,
          max_budget_type: result?.max_budget_type
            ? result?.max_budget_type
            : result?.customer_detail?.max_budget_type,
          min_emi_budget: result?.min_emi_budget
            ? result?.min_emi_budget
            : result?.customer_detail?.min_emi_budget,
          max_emi_budget: result?.max_emi_budget
            ? result?.max_emi_budget
            : result?.customer_detail?.max_emi_budget,
          min_emi_budget_type: result?.min_emi_budget_type
            ? result?.min_emi_budget_type
            : result?.customer_detail?.min_emi_budget_type,
          max_emi_budget_type: result?.max_emi_budget_type
            ? result?.max_emi_budget_type
            : result?.customer_detail?.max_emi_budget_type,
          preferred_bank: result?.preferred_bank
            ? result?.preferred_bank
            : result?.customer_detail?.preferred_bank,
          funding_type: result?.funding_type
            ? result?.funding_type
            : result?.customer_detail?.funding_type,
          purpose: result?.purpose
            ? result?.purpose
            : result?.customer_detail?.purpose,
          occupation: result?.occupation
            ? result?.occupation
            : result?.customer_detail?.occupation,
          coumpany_name: result?.coumpany_name
            ? result?.coumpany_name
            : result?.customer_detail?.coumpany_name,
          desigantion: result?.desigantion
            ? result?.desigantion
            : result?.customer_detail?.desigantion,
          office_address: result?.office_address
            ? result?.office_address
            : result?.customer_detail?.office_address,
          document: result?.document
            ? result?.document
            : result?.customer_detail?.document,
          // office_address: result?.house_no
          //   ? result?.house_no
          //   : result?.customer_detail?.house_no,
        });
      }
    }
  }, [verifyVisitorDetailSelector]);

  useEffect(() => {
    if (lead_id) {
      dispatch(visitorDetail({ lead_id: lead_id }));
    } else {
      dispatch(verifyVisitDetail({ customer_id: customer_id }));
    }
  }, []);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]:
        e.target.name === "adhar_no"
          ? e.target.value
            .replace(/\D/g, "")
            .split(/(?:([\d]{4}))/g)
            .filter((s) => s.length > 0)
            .join(" ")
          : e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      location: e,
      latitude: "",
      longitude: "",
    };
    setForm(nextFormState);
  };
  const onSelect = (latLng, location) => {
    const nextFormState = {
      ...form,
      location: location,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  const handleNext = () => {
    if (!handleValid()) {
      dispatch(bulkVerifyVisitForm(form));
      let leadId = lead_id ? "?lead_id=" + lead_id : "";
      navigatpage("/createLeadnext/" + customer_id + leadId);
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.first_name) {
      formError = true;
      err["first_name"] = strings.customerName_Err;
    } else if (!nameValid(form.first_name)) {
      formError = true;
      err["first_name"] = strings.nameValidErr;
    }
    if (!form.mobile) {
      formError = true;
      err["mobile"] = strings.mobileErr;
    } else if (!mobileNumberValid(form.mobile)) {
      formError = true;
      err["mobile"] = strings.mobileValidErr;
    }
    if (form.whatsapp_no && !mobileNumberValid(form.whatsapp_no)) {
      formError = true;
      err["whatsapp_no"] = strings.mobileValidErr;
    }
    if (form.adhar_no && !validateAadhaar(form.adhar_no)) {
      formError = true;
      err["adhar_no"] = strings.validAadhar_Err;
    }
    if (form.pancard_no && !pancardValidation(form.pancard_no)) {
      formError = true;
      err["pancard_no"] = strings.validPancard_Err;
    }
    if (form.email && !emailAddressValid(form.email)) {
      formError = true;
      err["email"] = strings.emailValidationErr;
    }
    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "Create Visitor",
      metaDescription: "create visitor",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.createvisitor}
        url={"/verify_lead"}
        parentListing={strings.verifyListing}
        titleactive={strings.CreateVisitor}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.createvisitor}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.propertyname}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlFirstName"
                          type="text"
                          name="property_title"
                          value={form.property_title}
                          readOnly
                          placeholder={strings.propertyname}
                          onChange={handleInputField}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.visitorFullName}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlFirstName"
                          type="text"
                          name="first_name"
                          value={form.first_name}
                          placeholder={strings.visitorFullName}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.first_name && (
                          <span style={{ color: "red" }}>
                            {formVaild?.first_name}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.mobileNo}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          type="number"
                          maxLength={10}
                          name="mobile"
                          value={form.mobile}
                          placeholder={strings.mobileNo}
                          autoComplete="off"
                          onChange={(event) => {
                            if (event.target.value.length <= 10) {
                              handleInputField(event);
                            }
                          }}
                        />
                        {formVaild?.mobile && (
                          <span style={{ color: "red" }}>
                            {formVaild?.mobile}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.emailAddress}
                        </label>
                        <input
                          className="form-control"
                          autoComplete="off"
                          id="exampleInputMobileNo"
                          type="email"
                          name="email"
                          value={form.email}
                          placeholder={strings.emailaddress}
                          onChange={handleInputField}
                        />
                        {formVaild?.email && (
                          <span style={{ color: "red" }}>
                            {formVaild?.email}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.maritalStatus}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="marital_status"
                          value={form.marital_status}
                          onChange={handleInputField}
                        >
                          <option defaultValue={null}>
                            {strings.selectMaritalStatus}
                          </option>
                          <option value={2}>{strings.married}</option>
                          <option value={1}>{strings.unmarried}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <AutocompletePlace
                          placeholder={strings.location}
                          value={form.location}
                          onChange={handleInputArea}
                          onSelect={onSelect}
                          label={strings.location}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.locality}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          type="text"
                          name="locality"
                          value={form.locality}
                          placeholder={strings.locality}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.whatsappNo}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          type="number"
                          maxLength={10}
                          name="whatsapp_no"
                          value={form.whatsapp_no}
                          placeholder={strings.whatsappNo}
                          onChange={(event) => {
                            if (event.target.value.length <= 10) {
                              handleInputField(event);
                            }
                          }}
                          autoComplete="off"
                        />
                        {formVaild?.whatsapp_no && (
                          <span style={{ color: "red" }}>
                            {formVaild?.whatsapp_no}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row pb-3">
                    <div className="row pl-4 ">
                      <label
                        htmlFor="exampleInputMobileNo "
                        className="pr-5"
                      >
                        {strings.gender}
                      </label>
                      <div className="form-check pr-5">
                        <input
                          className="form-check-input "
                          type="radio"
                          id="flexRadioDefault1"
                          name="gender"
                          value={1}
                          checked={form.gender == 1 ? true : false}
                          onChange={handleInputField}
                        />
                        <label
                          className="form-check-label"
                          for="flexRadioDefault1"
                        >
                          {strings.male}
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="flexRadioDefault2"
                          name="gender"
                          value={2}
                          checked={form.gender == 2 ? true : false}
                          onChange={handleInputField}
                        />
                        <label
                          className="form-check-label"
                          for="flexRadioDefault2"
                        >
                          {strings.female}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.dateofBirth}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          type="Date"
                          name="birth_date"
                          value={form.birth_date}
                          onChange={handleInputField}
                          min="1920-01-01"
                          max={moment()
                            .subtract(18, "years")
                            .format("yyyy-MM-DD")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.aadharNo}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlLastName"
                          type="text"
                          name="adhar_no"
                          maxLength={14}
                          value={form.adhar_no}
                          placeholder={strings.aadharNoExample}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.adhar_no && (
                          <span style={{ color: "red" }}>
                            {formVaild?.adhar_no}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.pancardNo}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="text"
                          name="pancard_no"
                          maxLength={10}
                          value={form.pancard_no}
                          placeholder={strings.panNumberExample}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.pancard_no && (
                          <span style={{ color: "red" }}>
                            {formVaild?.pancard_no}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.currentStay}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="current_stay"
                          value={form.current_stay}
                          onChange={handleInputField}
                        >
                          <option defaultValue={null}>
                            {strings.currentStayselect}
                          </option>
                          <option value={"Rented"}>{strings.rented}</option>
                          <option value={"Owned"}>{strings.owned}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.familyMember}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="number"
                          name="no_of_family_member"
                          value={form.no_of_family_member}
                          placeholder={strings.familyMember}
                          onChange={handleInputField}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            if (e.target.value.length >= 2) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleNext()}
                      >
                        {strings.next}
                      </button>
                    </div>
                  </div>
                  {!isEmpty(formVaild) && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          // padding: "5px 15px 25px 5px",
                        }}
                      >
                        {strings.fieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CreateLead;
